import React, { useState, useEffect, useRef } from 'react';
import profile from '../../../global/img/profile.png';
// import { Dropdown } from 'react-bootstrap';

// Function to replace t.co URLs with 'See more' links
const processTweetText = (text) => {
  if (!text) return '';
  // Regular expression to match t.co URLs
  const tcoUrlRegex = /(https?:\/\/t\.co\/[a-zA-Z0-9]+)/g;
  
  // Replace t.co URLs with 'See more' links
  return text.replace(tcoUrlRegex, (url) => {
    return ` <a href="${url}" target="_blank" rel="noopener noreferrer">See more</a>`;
  });
};

const TWEETS_PER_PAGE = 5;

// Removed SPORTS array and related logic

const TwitterFeed = ({ tweets = [], twitter_handle, twitter_profile_image }) => {
  const [visibleCount, setVisibleCount] = useState(TWEETS_PER_PAGE);
  const feedRef = useRef(null);

  useEffect(() => {
    setVisibleCount(TWEETS_PER_PAGE);
  }, [tweets]);

  // Infinite scroll handler
  useEffect(() => {
    const handleScroll = () => {
      if (!feedRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = feedRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10 && visibleCount < tweets.length) {
        setVisibleCount((prev) => Math.min(prev + TWEETS_PER_PAGE, tweets.length));
      }
    };
    const feedDiv = feedRef.current;
    if (feedDiv) {
      feedDiv.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (feedDiv) {
        feedDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [visibleCount, tweets.length]);

  const handleSeeMore = () => {
    setVisibleCount((prev) => Math.min(prev + TWEETS_PER_PAGE, tweets.length));
  };

  // No sport filtering, just show all tweets
  const visibleTweets = tweets.slice(0, visibleCount);

  // If no twitter handle, show full not found and hide rest
  if (!twitter_handle) {
    return (
      <div className="news-column twitter-feed" style={{ maxHeight: 500, overflowY: 'auto' }}>
        <div className="news-header">
          <img src="https://img.icons8.com/ios-filled/24/twitterx--v2.png" alt="X logo" />
        </div>
        <div className="news-post">
          <div className="post-profile">
            <span className="not-found-profile">Not Found</span>
          </div>
          <div className="news-body">
            <div className="post-header">
              <p><strong className="username">No Profile Image or Handle Found</strong></p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-column twitter-feed" ref={feedRef} style={{ maxHeight: 500, overflowY: 'auto' }}>
      <div className="news-header" style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, padding: '8px 0', borderBottom: '1px solid #eee' }}>
        <img src="https://img.icons8.com/ios-filled/24/twitterx--v2.png" alt="X logo" />
        {/* Removed Dropdown for sport selection */}
        <h2>@{twitter_handle}</h2>
      </div>
      {(!twitter_profile_image || !twitter_handle) ? (
        <div className="news-post">
          <div className="post-profile">
            <span className="not-found-profile">Not Found</span>
          </div>
          <div className="news-body">
            <div className="post-header">
              <p><strong className="username">No Profile Image or Handle Found</strong></p>
            </div>
          </div>
        </div>
      ) : visibleTweets.length === 0 ? (
        <div className="news-post">
          <div className="post-profile">
            <img src={twitter_profile_image} alt="profile" width="50px" />
          </div>
          <div className="news-body">
            <div className="post-header">
              <p><strong className="username">No Tweets Found</strong></p>
            </div>
          </div>
        </div>
      ) : (
        visibleTweets.map((tweet, idx) => (
          <div className="news-post" key={tweet.tweet_id || idx}>
            <div className="post-profile">
              <img src={twitter_profile_image} alt="profile" width="50px" />
            </div>
            <div className="news-body">
              <div className="post-header">
                <p>
                  <strong className="username">{twitter_handle ? twitter_handle : 'Player'}</strong>
                  <span className="postdate"> · {tweet.tweet_date ? new Date(tweet.tweet_date).toLocaleDateString() : ''}</span>
                </p>
              </div>
              <div className="post-body">
                <p dangerouslySetInnerHTML={{ __html: processTweetText(tweet.tweet_text) }}></p>
                {tweet.media_url ? (
                  <img className="postimg" src={tweet.media_url} alt="Tweet Media" />
                ) : null}
              </div>
            </div>
          </div>
        ))
      )}
      {visibleCount < tweets.length && (
        <p className="see-more" style={{ cursor: 'pointer' }} onClick={handleSeeMore}>see more</p>
      )}
    </div>
  );
};

export default TwitterFeed; 